import { TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { handleConnectionDetailChange } from '../../../utils';

interface GoogleDriveFieldsProps {
  isEditable: boolean;
  formValues: Record<string, string | string[]>;
  handleInputChange: (name: string, value: string) => void;
  onValidityChange: (isValid: boolean) => void;
}

const GoogleDriveFields: React.FC<GoogleDriveFieldsProps> = ({
  isEditable,
  formValues,
  handleInputChange,
  onValidityChange,
}) => {
  const connectionDetails = JSON.parse((formValues.connectionDetails as string) || '{}');

  useEffect(() => {
    const isAllValid =
      connectionDetails.iapFileDriveLink &&
      connectionDetails.iaaFileDriveLink &&
      connectionDetails.uaSpendFileDriveLink;
    onValidityChange?.(isAllValid);
  }, [connectionDetails]);

  return (
    <>
      <TextField
        label="IAP File Cloud Storage Link"
        placeholder="Paste Cloud Storage link here"
        value={connectionDetails.iapFileDriveLink}
        onChange={(e) =>
          handleConnectionDetailChange(
            'iapFileDriveLink',
            e.target.value,
            formValues,
            handleInputChange,
          )
        }
        sx={{
          width: '100%',
        }}
        disabled={!isEditable}
      />
      <TextField
        label="IAA File Cloud Storage Link"
        placeholder="Paste Cloud Storage link here"
        value={connectionDetails.iaaFileDriveLink}
        onChange={(e) =>
          handleConnectionDetailChange(
            'iaaFileDriveLink',
            e.target.value,
            formValues,
            handleInputChange,
          )
        }
        sx={{
          width: '100%',
        }}
        disabled={!isEditable}
      />
      <TextField
        label="UA Spend File Cloud Storage Link"
        placeholder="Paste Cloud Storage link here"
        value={connectionDetails.uaSpendFileDriveLink}
        onChange={(e) =>
          handleConnectionDetailChange(
            'uaSpendFileDriveLink',
            e.target.value,
            formValues,
            handleInputChange,
          )
        }
        sx={{
          width: '100%',
        }}
        disabled={!isEditable}
      />
    </>
  );
};

export default GoogleDriveFields;
